import React from 'react';
import { Modal, ModalDialog, ModalClose, Typography, Button, Box, Stack } from '@mui/joy';

interface InsufficientPermissionsModalProps {
  open: boolean;
  onClose: () => void;
}

const InsufficientPermissionsModal: React.FC<InsufficientPermissionsModalProps> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        aria-labelledby="insufficient-permissions-modal"
        size="sm"
        sx={{ maxWidth: 400, p: 3 }}
      >
        <ModalClose />
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography
            component="h2"
            level="h4"
            sx={{ mb: 2, color: 'danger.500' }}
          >
            Insufficient Permissions
          </Typography>
          <Typography level="body-md" sx={{ mb: 3, color: 'neutral.600' }}>
            You do not have permission to access this data or perform this action.
          </Typography>
          <Stack spacing={2}>
            <Button
              onClick={onClose}
              size="lg"
              sx={{ width: '100%' }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </ModalDialog>
    </Modal>
  );
};

export default InsufficientPermissionsModal; 